/** Boot Firestore / lazy-chunk waits. Long enough for a normal getDoc, short enough a hang is obvious. */
export const BOOT_FS_TIMEOUT_MS = 8_000

export class TimeoutError extends Error {
  readonly timedOut = true

  constructor(label: string, ms: number) {
    super(`${label} timed out after ${Math.round(ms / 1000)}s`)
    this.name = 'TimeoutError'
  }
}

export function isTimeoutError(err: unknown): boolean {
  return (
    err instanceof TimeoutError ||
    (typeof err === 'object' && err != null && 'timedOut' in err && (err as { timedOut?: unknown }).timedOut === true)
  )
}

/**
 * Reject after `ms` so a hung promise cannot block POS boot forever.
 * The underlying work is not cancelled.
 */
export function withTimeout<T>(promise: Promise<T>, ms: number, label: string): Promise<T> {
  return new Promise<T>((resolve, reject) => {
    const timer = setTimeout(() => {
      reject(new TimeoutError(label, ms))
    }, ms)
    promise.then(
      (value) => {
        clearTimeout(timer)
        resolve(value)
      },
      (err) => {
        clearTimeout(timer)
        reject(err)
      },
    )
  })
}
